import axios from "axios";
import { toast } from "react-toastify";
import UserService from "./UserService";

const ApiService = {
  post: async (path: string, payload: any) => {
    const token = localStorage.getItem("user-token");
    const params = payload;
    const data = JSON.stringify(params);
    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_DELEND_API}/${path}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config)
      .then((response) => {
        return response;
      })
      .catch(async (error) => {
        if (error.response?.status === 403) {
          const refreshToken = await UserService.refreshToken();
          if (refreshToken?.status === 200) {
            const refreshedToken = localStorage.getItem("user-token");
            config.headers = {
              Authorization: `Bearer ${refreshedToken}`,
              "Content-Type": "application/json",
            };
            return axios(config)
              .then((response) => {
                return response;
              })
              .catch(async () => {
                localStorage.removeItem("user-token");
                window.location.replace("/");
              });
          } else {
            localStorage.removeItem("user-token");
            window.location.replace("/");
          }
        }
        toast.error(error.response?.data?.message);
        return error.response;
      });
  },
  get: async (path: string, params?: any) => {
    const prepareQueryParam = (params: any) => {
      let queryParam = "?";
      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          queryParam += `${key}=${value}&`;
        });
      }
      return queryParam.slice(0, -1);
    };

    const token = localStorage.getItem("user-token");
    const queryParam = prepareQueryParam(params);
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_DELEND_API}/${path}${queryParam}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    return axios(config)
      .then((response) => {
        return response;
      })
      .catch(async (error) => {
        if (error.response?.status === 403) {
          const refreshToken = await UserService.refreshToken();
          if (refreshToken?.status === 200) {
            const refreshedToken = localStorage.getItem("user-token");
            config.headers = {
              Authorization: `Bearer ${refreshedToken}`,
              "Content-Type": "application/json",
            };
            return axios(config)
              .then((response) => {
                return response;
              })
              .catch(async () => {
                localStorage.removeItem("user-token");
                window.location.replace("/");
              });
          } else {
            localStorage.removeItem("user-token");
            window.location.replace("/");
          }
        }

        toast.error(error.response?.data?.message);
        return error.response;
      });
  },
};

export default ApiService;
